const $ = window.jQuery

const initializeMatchHeight = () => {
  $(() => $('.matchheight').matchHeight())
}

initializeMatchHeight()

window.initializeMatchHeight = initializeMatchHeight
